"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Button_1 = __importDefault(require("@mui/material/Button"));
var colors_1 = require("@mui/material/colors");
var FreeSampleButton = function (_a) {
    var freeSampleUrl = _a.freeSampleUrl;
    var FreeSampleButton = (0, material_1.styled)(Button_1.default)(function (_a) {
        var theme = _a.theme;
        return ({
            color: '#fff',
            backgroundColor: colors_1.red[500],
            '&:hover': {
                backgroundColor: colors_1.red[700],
            },
        });
    });
    var openSampleFile = function () {
        window.open(freeSampleUrl, '_blank', 'noreferrer');
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "freesample-button" }, { children: (0, jsx_runtime_1.jsx)(FreeSampleButton, __assign({ onClick: function () { return openSampleFile(); } }, { children: "Ver muestra gratuita" })) })));
};
exports.default = FreeSampleButton;
//# sourceMappingURL=FreeSampleButton.js.map